import type { Locale } from './locales'
import type { RouteKey } from './routeDefs'

export const routeTranslations: Record<RouteKey, Record<Locale, string>> = {
  home: { no: '', en: '' },
  notFound: { no: '404', en: '404' },
  preview: { no: 'preview', en: 'preview' },
  post: { no: ':category/:slug', en: ':category/:slug' },
  page: { no: ':slug', en: ':slug' },
}

export type RouteName = RouteKey
